import React, { useContext } from 'react';
import Card from '../../components/card.component';
import FacturacionComponent from './facturacion.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faBoxes,
} from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router';
import { ConfigContext } from '../../context/config.context';



const FacturacionView = () => {

  const history = useHistory();
  const { config } = useContext(ConfigContext);

  return (
    <>
      <Card>
        <div className="d-flex justify-content-end">
           {config.tipo === 1 ?
              <button type="button" className="btnx btnx-warn mr-2" onClick={() => history.push('/ventas/productos')}>
                  <FontAwesomeIcon icon={faBoxes} /> Gestionar productos
              </button>
           : null}
            <button type="button" className="btnx btnx-warn" onClick={() => history.push('/boletas/listado')}>
                <FontAwesomeIcon icon={faSearch} /> Buscar recibos de pago
            </button>
        </div>
      </Card>
      <Card className="mt-2">
          <FacturacionComponent/>
      </Card>
    </>
  )
}

export default FacturacionView;